<template>
  <!-- Modal terms -->
  <div
    class="modal fade"
    id="rental-agreement-file-ex"
    tabindex="-1"
    role="dialog"
    aria-labelledby="termsLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="termsLabel">{{ $t('Kira Sözleşmesi') }}</h4>
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
        </div>
        <div class="modal-body modal-body-min">
          <img src="/img/ornek-dokumanlar/kira-kontrat-ornegi.jpg" class="full-width" />
        </div>
        <div class="modal-footer">
          <button type="button" class="btn_1" data-dismiss="modal">{{ $t('Kapat') }}</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
  <!-- Modal home rental contract -->
</template>
<script>
export default {
  name: 'HomeRentalContractModal',
};
</script>
